/** Sentinel option id for clearing every tax line. Not a real tax line id. */
export const NO_TAX_OPTION_ID = "no-tax";

export function isNoTaxOption(value: string | number): boolean {
  return value === NO_TAX_OPTION_ID;
}

/** Tax lines after choosing "No tax" or toggling one line. */
export function nextSelectedTaxLineIds(current: number[], value: string | number): number[] {
  if (isNoTaxOption(value)) {
    return [];
  }

  const taxLineId = Number(value);
  if (!Number.isFinite(taxLineId)) {
    return current;
  }

  return current.includes(taxLineId) ? current.filter(id => id !== taxLineId) : [...current, taxLineId];
}

export function taxLineSelectOptions(
  taxLines: Array<{ id: number; name: string }> | undefined,
  noTaxLabel: string,
) {
  return [
    { id: NO_TAX_OPTION_ID, label: noTaxLabel },
    ...(taxLines ?? []).map(taxLine => ({
      id: taxLine.id,
      label: taxLine.name,
    })),
  ];
}

/** Show "No tax" as the selected value when no tax lines are chosen. */
export function taxLineSelectValue(selectedTaxLineIds: number[] | undefined): Array<string | number> {
  if (!selectedTaxLineIds || selectedTaxLineIds.length === 0) {
    return [NO_TAX_OPTION_ID];
  }

  return selectedTaxLineIds;
}
